import * as ReactGA from 'react-ga';
import { REACT_APP_TRACKING_CODE } from '../../config';

ReactGA.initialize(REACT_APP_TRACKING_CODE);

const gaPageViewMiddleware = (store) => (next) => (action) => {
  if (action.type === 'HISTORY_LOCATION_CHANGE') {
    const { pathname } = action;

    if (window.performance) {
      const performanceEntries = window.performance.getEntries();

      performanceEntries.forEach((entry) => {
        // window.PerformanceNavigationTiming and window.PerformanceResourceTiming aren't existing in safari
        // TODO find a solution for safari
        if (((window.PerformanceNavigationTiming && entry instanceof window.PerformanceNavigationTiming)
          || (window.PerformanceResourceTiming && entry instanceof window.PerformanceResourceTiming))
          // this condition only to avoid warning, zero values in any case are not processed
          // TODO check if react-ga works s designed or do we need to change a version
          && entry.duration > 0) {
          ReactGA.timing({
            category: entry.initiatorType,
            variable: 'load',
            value: Math.round(entry.duration),
            label: entry.name,
          });
        }
      });

      window.performance.clearResourceTimings();
    }

    ReactGA.set({ page: pathname });
    ReactGA.pageview(pathname);
  }

  return next(action);
};

export default gaPageViewMiddleware;
